import { Component, inject } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from 'src/app/services/utils/loading.service';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  standalone: true,
  imports: [SHARED_IMPORTS, ProgressSpinnerModule]
})
export class LoadingComponent {
  private loadingService = inject(LoadingService);

  isLoading = this.loadingService.loading$;
}
